/** Mirrors the backend's `@vv/rbac` TeamRole - duplicated here since the
 * frontend and backend are separate workspaces/deployments. */
export enum TeamRole {
  Requestor = "Requestor",
  ValidationManager = "ValidationManager",
  ValidationEngineer = "ValidationEngineer",
}

export const ALL_TEAM_ROLES: TeamRole[] = Object.values(TeamRole);

export const TEAM_ROLE_LABELS: Record<TeamRole, string> = {
  [TeamRole.Requestor]: "Requestor",
  [TeamRole.ValidationManager]: "Validation Manager",
  [TeamRole.ValidationEngineer]: "Validation Engineer",
};

export interface Team {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface TeamMember {
  id: string;
  teamId: string;
  userId: string;
  role: TeamRole;
  joinedAt: string;
}

export interface CreateTeamRequest {
  name: string;
  description?: string;
}

export interface UpdateTeamRequest {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface AddTeamMemberRequest {
  userId: string;
  role: TeamRole;
}
